import React, { useState } from 'react'
import { LinearProgress } from '@material-ui/core'

import {
  useGlobalContext,
  layerAdded,
  indicatorTabChange
} from '../../../state'
import {
  getIndicatorParams,
  useLayerIndicator,
  getPaintIndicator
} from '../../../utils/indicatorHelper'

import { Dimensions } from './Dimensions'

import { LAYER_KIND } from '../../../utils/configQueries'

export const Indicator = ({ id, dimensions }) => {
  const { dispatch } = useGlobalContext()
  const isCountry = !dimensions.some(({ id }) => id === 79515)

  const [newIndicator, setNewIndicator] = useState({
    id: 'emptyLayer',
    type: 'fill',
    paint: {},
    dataIndicator: null,
    steps: null,
    stepsColor: null
  })

  useLayerIndicator({ newIndicator })

  const handleAddLayer = async (values) => {
    const dimensionType = Object.values(values).filter((k) => !parseInt(k))

    // cities_depualc is the only circle type layer (for the moment)
    const currentLayerType = dimensionType.includes('cities_depualc')
      ? 'circle'
      : 'fill'
    const currentIdLayer = `indicator-${id}-${currentLayerType}`

    const members = Object.values(values).filter((k) => parseInt(k))
    const {
      geojson,
      steps: stepsAux,
      stepsColor,
      metadata
    } = await getIndicatorParams({
      indicatorId: id,
      members,
      isCountry,
      dimensionType
    })

    setNewIndicator({
      id: currentIdLayer,
      type: currentLayerType,
      paint: getPaintIndicator.get(currentLayerType),
      dataIndicator: geojson,
      steps: stepsAux,
      stepsColor
    })

    dispatch(
      layerAdded({
        id: currentIdLayer,
        layerType: currentLayerType,
        membersValues: values,
        metadata,
        dimensions,
        isVisible: true,
        steps: stepsAux,
        includeName: true,
        includeValue: false,
        opacity: 100,
        idPaint: 4,
        kind: LAYER_KIND.INDICATOR,
        isCountry
      })
    )
    dispatch(indicatorTabChange(true))
  }

  return (
    <>
      {!dimensions.length ? (
        <LinearProgress />
      ) : (
        <Dimensions onAddLayer={handleAddLayer}>{dimensions}</Dimensions>
      )}
    </>
  )
}
